import { render, staticRenderFns } from "./CreditDebt.vue?vue&type=template&id=b42ab7a8&scoped=true&"
import script from "./CreditDebt.vue?vue&type=script&lang=js&"
export * from "./CreditDebt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42ab7a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b42ab7a8')) {
      api.createRecord('b42ab7a8', component.options)
    } else {
      api.reload('b42ab7a8', component.options)
    }
    module.hot.accept("./CreditDebt.vue?vue&type=template&id=b42ab7a8&scoped=true&", function () {
      api.rerender('b42ab7a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Credit/CreditDebt.vue"
export default component.exports